module.exports = __webpack_public_path__ + "img/overseas_1.f71337ac.jpg";